import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import ROSLIB from "roslib";
import { buildWsUrl } from "../utils/wsUrl";

// Connection states: DISCONNECTED → CONNECTING → CONNECTED → RECONNECTING
export const ConnectionState = {
  DISCONNECTED: "DISCONNECTED",
  CONNECTING: "CONNECTING",
  CONNECTED: "CONNECTED",
  RECONNECTING: "RECONNECTING",
};

const rosObj = {
  ROS: new ROSLIB.Ros(),
  url: buildWsUrl("localhost"),
  isConnected: false,
  connectionState: ConnectionState.DISCONNECTED,
  ROSConfirmedConnected: false,
  autoconnect: true,
  topics: [],
  services: [],
  listeners: [],
  publishers: [],
};

const ROSContext = createContext([{}, () => {}]);

const ROSProvider = (props) => {
  const [ros, setROS] = useState(rosObj);
  return (
    <ROSContext.Provider value={[ros, setROS]}>
      {props.children}
    </ROSContext.Provider>
  );
};

ROSProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { ROSContext, ROSProvider };
